import React, { useCallback } from 'react';
import { useRedirect } from 'react-admin';
import {
  Navigate,
  Outlet,
  Route,
  Routes,
} from 'react-router-dom';
import { Grid } from '@mui/material';

import { StyledTab, StyledTabs } from '../../../layout/Tab';
import SubNavigation from '../../../layout/SubNavigation';

import GeneralCompanyInformation from './GeneralCompanyInformation';
import CompanyRepresentation from './CompanyRepresentation';
import CreditReport from './CreditReport';
import OwnerShip from './OwnerShip';
import FinancialData from './FinancialData';
import SanctionList from './SanctionList';
import RelatedIndividualsList from './relatedIndividuals/RelatedIndividualsList';
import useCurrentTab from '../../../../hooks/useCurrentTab';
import AdverseMedia from './adverseMedia';
import IpScreenings from '../../../entities/IpScreenings';

const KycDataTabs = () => {
  const redirect = useRedirect();

  const handleKycTabChange = useCallback((
    _event: React.SyntheticEvent<Element, Event>,
    newValue: string,
  ) => {
    redirect(`../${newValue}`);
  }, [redirect]);

  const activeTab = useCurrentTab();

  return (
    <Routes>
      <Route
        path="*"
        element={(
          <Grid container spacing={4}>
            <Grid size={12}>
              <SubNavigation>
                <StyledTabs value={activeTab === '' ? 'general' : activeTab} onChange={handleKycTabChange}>
                  <StyledTab label="General" value="general" />
                  <StyledTab label="Company representation" value="company-representation" />
                  <StyledTab label="Credit report" value="credit-report" />
                  <StyledTab label="Ownership" value="ownership" />
                  <StyledTab label="Financial data" value="financial-data" />
                  <StyledTab label="Sanction list" value="sanction-list" />
                  <StyledTab label="Adverse media" value="adverse-media" />
                  <StyledTab label="Related individuals" value="related-individuals" />
                  <StyledTab label="IP screenings" value="ip-screenings" />
                </StyledTabs>
              </SubNavigation>
            </Grid>
            <Grid size={12}>
              <Outlet />
            </Grid>
          </Grid>
        )}
      >
        <Route index element={<Navigate to="general" replace />} />
        <Route path="general" element={<GeneralCompanyInformation />} />
        <Route path="company-representation" element={<CompanyRepresentation />} />
        <Route path="credit-report" element={<CreditReport />} />
        <Route path="ownership" element={<OwnerShip />} />
        <Route path="financial-data" element={<FinancialData />} />
        <Route path="sanction-list">
          <Route path="*" element={<SanctionList />} />
        </Route>
        <Route path="adverse-media">
          <Route path="*" element={<AdverseMedia />} />
        </Route>
        <Route path="related-individuals" element={<RelatedIndividualsList />} />
        <Route path="ip-screenings" element={<IpScreenings />} />
      </Route>
    </Routes>
  );
};

export default KycDataTabs;
